import { Schema } from 'rsuite';
import {
  companyNameValidation,
  emailValidation,
  phoneRequiredValidation,
} from 'src/common/validation';
import { validationNameRegex } from 'src/common/regex';
import { FormModelPerson } from 'src/types/person';

const { BooleanType, StringType } = Schema.Types;

export const formValuePersonSchema = {
  companyName: companyNameValidation,
  email: emailValidation,
  firstName: StringType()
    .pattern(
      validationNameRegex,
      'Enter a first name using letters, spaces, or hyphens only'
    )
    .isRequired('Enter your first name'),
  lastName: StringType()
    .pattern(
      validationNameRegex,
      'Enter a last name using letters, spaces, or hyphens only'
    )
    .isRequired('Enter your last name'),
  mailingAddress: StringType().isRequired('Enter your mailing address'),
  phone: phoneRequiredValidation,
  sameAsPropertyAddress: BooleanType(),
};

export const FormValuesPerson = Schema.Model<FormModelPerson>(
  formValuePersonSchema
);
